import { Box, Skeleton } from '@mui/material';
import React from 'react';
import ExerciseCardSkeleton from '../exercise-card/ExerciseCardSkeleton';

const ScheduledExercisesSkeleton = () => {
  return (
    <>
      <Box display="flex" sx={{ borderBottom: 1, borderColor: 'divider', mb: 8 }}>
        <Box display="flex" gap={2} sx={{ fontSize: '1.5rem', width: 155, height: 48 }}>
          <Skeleton sx={{ flex: 1 }} />
          <Skeleton sx={{ flex: 1 }} />
        </Box>
      </Box>
      <Box display={{ sm: 'flex', xs: 'grid' }} gap={3}>
        <ExerciseCardSkeleton />
        <ExerciseCardSkeleton />
      </Box>
      <Box display={{ sm: 'flex', xs: 'grid' }} gap={3}>
        <ExerciseCardSkeleton />
        <ExerciseCardSkeleton />
      </Box>
      <Box display={{ sm: 'flex', xs: 'grid' }} gap={3}>
        <ExerciseCardSkeleton />
        <ExerciseCardSkeleton />
      </Box>
      <Box display={{ sm: 'flex', xs: 'grid' }} gap={3}>
        <ExerciseCardSkeleton />
        <ExerciseCardSkeleton />
      </Box>
    </>
  );
};

export default ScheduledExercisesSkeleton;
